import { apiZoho } from '#plugins/axios.js';

export const getInvoicesByUser = async (userId) => {
  const response = await apiZoho.get('Remision_Report', {
    params: {
      where: `Cliente==${userId}&&Saldo!=0`,
    },
  });

  return response.data.data;
};
